import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  left: 8px;\n  position: absolute;\n  top: 8px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  box-shadow: ", ";\n  max-width: ", ";\n  width: ", ";\n\n  &:empty {\n    display: none;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  min-width: 1px; /* Fix for left navigation bar */\n  position: relative;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-right: 1px solid ", ";\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 1;\n  min-width: ", ";\n  position: relative;\n  width: ", ";\n\n  &:empty {\n    display: none;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  padding-top: ", "px;\n  position: relative;\n\n  /*\n    * Shadow and space for header is always reserved with HeaderShadow\n    * for all sections, so move it to that space.\n  */\n  > ", " {\n    box-shadow: none;\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    z-index: ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: 1;\n  overflow: hidden;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: 1;\n  min-width: 1px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { color, property } from '@scp/ui-shared/theme/variables'; // eslint-disable-next-line import/no-relative-parent-imports

import { HeaderWrapper, HEADER_HEIGHT } from '../Header';
import { COLUMN_SIZE, LAYOUT_Z_INDEX_MAP } from './constants';
export var MainScreen = styled.div(_templateObject());
export var MainContent = styled.main(_templateObject2());
export var HeaderShadow = styled(HeaderWrapper).attrs({
  as: 'div'
})(_templateObject3(), LAYOUT_Z_INDEX_MAP.HEADER_SHADOW);
export var Column = styled.section(_templateObject4(), HEADER_HEIGHT, HeaderWrapper, LAYOUT_Z_INDEX_MAP.REAL_HEADER);
export var LeftColumn = styled(Column)(_templateObject5(), color.background, color.border, COLUMN_SIZE.MIN_WIDTH_LEFT, COLUMN_SIZE.LEFT);
export var CenterColumn = styled(Column)(_templateObject6());
export var RightColumn = styled(Column).attrs({
  as: 'aside'
})(_templateObject7(), color.background, property.boxShadow, function (props) {
  return !props.fixedWidth ? COLUMN_SIZE.RIGHT : 'none';
}, function (props) {
  return props.fixedWidth ? COLUMN_SIZE.RIGHT : 'auto';
});
export var SkipWrapper = styled.div(_templateObject8());